<template>
  <div>
    <div class="form-group">
      <label for="company_no" class="col-md-4 control-label">
        {{ $t('Registered company name') }} *
      </label>
      <div class="col-md-6">
        <input
          v-model="usBusinessEntityName"
          class="form-control"
          :placeholder="$t('Registered company name')"
          name="us_business_entity_name"
          type="text"
        />
      </div>
    </div>
    <div class="form-group">
      <label class="col-md-4 control-label" for="company_no">
        {{ $t('EIN') }}
        <CompanyNumberTooltip market="US" />
      </label>
      <div class="col-md-3">
        <input
          v-model="usEinNo"
          class="form-control"
          :placeholder="$t('EIN')"
          name="ein_no"
          type="text"
        />
      </div>
    </div>

    <div class="form-group">
      <div class="col-md-6 col-md-offset-4 col-xs-12">
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <submit-button :disabled="!canSave" :text="$t('Save')" auto-submit />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable import-x/extensions */
import CompanyNumberTooltip from '@/components/compliances/BusinessEntity/CompanyNumberTooltip.vue'
import { deepClone } from '@/utils/tools'

export default {
  name: 'CompanyUsBusinessEntityForm',
  components: { CompanyNumberTooltip },
  props: {
    businessEntity: {
      type: Object,
      required: true,
    },
  },
  data() {
    const internalBusinessEntity = deepClone(this.businessEntity)
    return {
      internalBusinessEntity,
    }
  },
  computed: {
    canSave() {
      return this.usBusinessEntityName !== null && this.usBusinessEntityName !== ''
    },
    usBusinessEntityName: {
      get() {
        return this.internalBusinessEntity.companyName
      },
      set(usBusinessEntityName) {
        this.internalBusinessEntity.companyName = usBusinessEntityName
        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },
    usEinNo: {
      get() {
        return this.internalBusinessEntity.companyNo
      },
      set(usEinNo) {
        this.internalBusinessEntity.companyNo = usEinNo
        this.$emit('update:businessEntity', this.internalBusinessEntity)
      },
    },
  },
}
</script>
